export default {
    CURRENT_CUSTOMER_CHECK: 'CURRENT_CUSTOMER_CHECK',
    CURRENT_CUSTOMER: 'CURRENT_CUSTOMER',
    USER_TYPE: 'USER_TYPE',
    CONTACT_INFO_NOTICE: 'CONTACT_INFO_NOTICE',
    CONTACT_INFO: 'CONTACT_INFO',
    COMPANY_INFO: 'COMPANY_INFO',
    COMPLETE: 'COMPLETE',
};
